const captureException = (error, errorInfo) => {
  if (typeof Sentry !== 'undefined') {
    Sentry.captureException(error, errorInfo)
  }
}

export default captureException
